import React from "react";

class Footer extends React.Component<any, any> {
  public render() {
    return <div className="footer" />;
  }
}

export default Footer;
